/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuoteSettingsUpdateRequest
 */
export interface QuoteSettingsUpdateRequest {
    /**
     * 
     * @type {boolean}
     * @memberof QuoteSettingsUpdateRequest
     */
    showFeesOnQuote: boolean;
}

/**
 * Check if a given object implements the QuoteSettingsUpdateRequest interface.
 */
export function instanceOfQuoteSettingsUpdateRequest(value: object): value is QuoteSettingsUpdateRequest {
    if (!('showFeesOnQuote' in value) || value['showFeesOnQuote'] === undefined) return false;
    return true;
}

export function QuoteSettingsUpdateRequestFromJSON(json: any): QuoteSettingsUpdateRequest {
    return QuoteSettingsUpdateRequestFromJSONTyped(json, false);
}

export function QuoteSettingsUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteSettingsUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'showFeesOnQuote': json['showFeesOnQuote'],
    };
}

export function QuoteSettingsUpdateRequestToJSON(value?: QuoteSettingsUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'showFeesOnQuote': value['showFeesOnQuote'],
    };
}

